import {onDomReady} from "../../components/dynamic/observer";

class FilterCloser {
    constructor() {
        this.sideFilter = document.querySelector('[data-side-filter]');
        this.isMobile = window.innerWidth < 1280
        this.init();
    }

    init() {
        this.initEvents();
    }

    initEvents() {
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 1280
        });

        document.addEventListener('submitSideFilterForm', () => {
            if (this.isMobile && this.sideFilter.classList.contains('_open')) {
                this.sideFilter.classList.remove('_open');
            }
        });
    }
}

onDomReady(() => {
    new FilterCloser();
});